import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";
// const Tab = ({ label, onClick, isActive }) => {
//   return (
//     <a
//       href="#"
//       onClick={onClick}
//       className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium ${isActive
//         ? 'border-green-500 text-green-600'
//         : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-white'
//         }`}
//     >
//       {label}
//     </a>
//   );
// };
const Tab = ({ label, onClick, isActive }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium ${
        isActive
          ? "border-green-500 text-green-600"
          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-white"
      }`}
    >
      {label}
    </button>
  );
};

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data;

  const [activeTab, setActiveTab] = useState("1");

  const handleTabClick = (label) => {
    setActiveTab(label);
  };
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  const itineraryText = result?.itinerary?.map((day, index) => {
    const dayKey = `day_${index}`;
    const fromKey = `from_name_${index}`;
    const toKey = `to_name_${index}`;
    const kmKey = `km_${index}`;
    const durationKey = `duration_${index}`;
    const itineraryKey = `itinerary_${index}`;

    return (
      <div key={index}>
        <h3>
          <b>{day[dayKey]}:</b>
        </h3>
        <p>
          {day[fromKey]} - {day[toKey]} ({day[kmKey]} kms/ approx{" "}
          {day[durationKey]}) {day[itineraryKey]}
        </p>
      </div>
    );
  });

  function formatDate(dateString) {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const year = date.getFullYear(); // Get 4-digit year
    return `${day}-${month}-${year}`; // Return in desired format
  }
  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn
          onClose={closeModal}
          />
          <nav className="-mb-px flex gap-6" aria-label="Tabs">
            <Tab
              label="Route"
              onClick={() => handleTabClick("1")}
              isActive={activeTab === "1"}
            />
            <Tab
              label="Itinerary"
              onClick={() => handleTabClick("2")}
              isActive={activeTab === "2"}
            />

            <Tab
              label="Vehicle Price"
              onClick={() => handleTabClick("3")}
              isActive={activeTab === "3"}
            />
          </nav>

          {/* Tab Content */}
          <div
            className="p-4 overflow-y-scroll"
            style={{ maxHeight: "60vh", scrollbarWidth: "thin" }}
          >
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Route
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.route}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Package Code
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.package_code}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Kilometer
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.kilometer_limit}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      No of Nights / Days
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.no_of_nights}/ {result?.no_of_days}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Arrival City
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.arrival_name}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Departure City
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.departure_name}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
            {activeTab === "2" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5 ">
                <dl className="-my-3 divide-y divide-gray-100 dark:divide-gray-600 text-sm dark:text-white p-3">
                  {itineraryText}
                </dl>
              </div>
            )}
            {activeTab === "3" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5 ">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Start Date
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2">
                      {formatDate(result?.start_from)}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      End Date
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2">
                      {formatDate(result?.end_to)}
                    </dd>
                  </div>

                  <div className="p-3">
                    <div className="grid grid-cols-3 gap-4 text-center font-medium text-gray-900 dark:text-white">
                      <div className="col-span-1 text-left">
                        <strong>Vehicle Type</strong>
                      </div>
                      <div className="col-span-1 text-left">
                        <strong>Price</strong>
                      </div>
                      <div className="col-span-1 text-left">
                        <strong>Prime %</strong>
                      </div>
                    </div>
                    <br />
                    {result.vehicle_type.map((type) => (
                      <div
                        key={type}
                        className="grid grid-cols-3 gap-4 text-center text-gray-700 dark:text-white"
                      >
                        <div className="col-span-1 text-left">
                          {result.vehicle_type_names[type]}
                        </div>
                        <div className="col-span-1 text-left">
                          {result.rate[type]}
                        </div>
                        <div className="col-span-1 text-left">
                          {result.prime[type]}
                        </div>
                      </div>
                    ))}
                  </div>
                </dl>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
